import {hAreaCodeEnum} from 'hiya-common/src/reducers/env'
import {useSelector} from 'react-redux'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'
import {ModelType} from '~/pages/ToyBricks/serve'

export enum LocationStatusEnum {
  //   0:未到达 1:已到达 2:已领取奖励 3、未解锁
  未到达 = 0,
  已到达 = 1,
  已领取奖励 = 2,
  未解锁 = 3,
}

const getImgSrc = (key, getImages = require.context('./images', false)) => {
  const rewardPng = getImages
  const src = rewardPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewardPng(src)
}

export enum LocationEnumType {
  村里客栈 = 1,
  镇上客栈 = 2,
  终点大驿站 = 3,
  邻镇旅馆 = 4,
}

export enum RewardTypeEnum {
  金币 = 4,
  自定义积分 = 18,
}

export const NumberImages = {
  0: getImgSrc('0', require.context('./images/number', false)),
  1: getImgSrc('1', require.context('./images/number', false)),
  2: getImgSrc('2', require.context('./images/number', false)),
  3: getImgSrc('3', require.context('./images/number', false)),
  4: getImgSrc('4', require.context('./images/number', false)),
  5: getImgSrc('5', require.context('./images/number', false)),
  6: getImgSrc('6', require.context('./images/number', false)),
  7: getImgSrc('7', require.context('./images/number', false)),
  8: getImgSrc('8', require.context('./images/number', false)),
  9: getImgSrc('9', require.context('./images/number', false)),
  k: getImgSrc('K', require.context('./images/number', false)),
  m: getImgSrc('M', require.context('./images/number', false)),
  '.': getImgSrc('点', require.context('./images/number', false)),
  '/': getImgSrc('斜杆', require.context('./images/number', false)),
}

export const FeedNumberImages = {
  0: getImgSrc('0', require.context('./images/number1', false)),
  1: getImgSrc('1', require.context('./images/number1', false)),
  2: getImgSrc('2', require.context('./images/number1', false)),
  3: getImgSrc('3', require.context('./images/number1', false)),
  4: getImgSrc('4', require.context('./images/number1', false)),
  5: getImgSrc('5', require.context('./images/number1', false)),
  6: getImgSrc('6', require.context('./images/number1', false)),
  7: getImgSrc('7', require.context('./images/number1', false)),
  8: getImgSrc('8', require.context('./images/number1', false)),
  9: getImgSrc('9', require.context('./images/number1', false)),
}

const logicIds = {
  [ModelType.普通任务系统]: {
    [hAreaCodeEnum.tr]: 1716807026,
    [hAreaCodeEnum.hk]: 1716807026,
    [hAreaCodeEnum.id]: 1716807026,
    [hAreaCodeEnum.vi]: 1716807026,
    [hAreaCodeEnum.tp]: 1716807026,
    [hAreaCodeEnum.pk]: 1716807026,
    [hAreaCodeEnum.hi]: 1716807026,
    [hAreaCodeEnum.ar]: 1716807026,
    [hAreaCodeEnum.ms]: 1716807026,
    [hAreaCodeEnum.th]: 1716807026,
  },
}
const useLogicId = ({modeType}: {modeType: ModelType}) => {
  const {h_area_code} = useSelector((s) => s.env.deviceinfo)
  return logicIds[modeType][h_area_code] || 0
}
export {useLogicId}

export enum JobTypeEnum {
  普通任务 = 1,
  可重复完成任务 = 2,
}

// 任务状态: 0: 未完成;1:已完成;2:完成并领取奖励
export enum JobStatusEnum {
  未完成 = 0,
  已完成 = 1,
  完成并领取奖励 = 2,
}

// feed_type	number	0: 投喂一次；1: 投喂全部
export enum FeedTypeEnum {
  投喂一次 = 0,
  投喂全部 = 1,
}

export const RuleBgConfig = {
  width: '100%',
  height: 'auto',
  bgs: {
    top: {
      backgroundImage: `${HostMaps.auto.otherStatic}/static/all/69ae6cd18767c3a943fcf724`,
    },
    center: {
      backgroundImage: `${HostMaps.auto.otherStatic}/static/all/69ae6d348767c3a943fcf727`,
    },
    bottom: {
      backgroundImage: `${HostMaps.auto.otherStatic}/static/all/69ae6cd78767c3a943fcf726`,
    },
  },
}

// 榜单分页上限
export const RankLimit = 5

export enum RewardSizeEnum {
  Small = 1,
  Large,
}

// 0=护卫商队页面
// 1=投喂榜单页面
export enum PageTypeEnum {
  护卫商队页面 = 0,
  投喂榜单页面 = 1,
}

export const TaskBgConfig = {
  width: '100%',
  height: 'auto',
  bgs: {
    top: {
      backgroundImage: `${HostMaps.auto.otherStatic}/static/all/69b3af528767c3a943fcf738`,
    },
    center: {
      backgroundImage: `${HostMaps.auto.otherStatic}/static/all/69b3af558767c3a943fcf739`,
    },
    bottom: {
      backgroundImage: `${HostMaps.auto.otherStatic}/static/all/69b3af578767c3a943fcf73a`,
    },
  },
}

export enum FeedStatusEnum {
  //  0:失败 1:成功 2:草料不足 3:已达到完成上限
  失败 = 0,
  成功 = 1,
  草料不足 = 2,
  已达到完成上限 = 3,
}
